import router from '@/router'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

import App from './App.vue'

// Initialize viewport variables
function initViewport() {
    const vh = window.innerHeight * 0.01
    const vw = window.innerWidth * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
    document.documentElement.style.setProperty('--vw', `${vw}px`)
}

// Set viewport variables on load and resize
initViewport()
window.addEventListener('resize', initViewport)
window.addEventListener('orientationchange', initViewport)

// Import global components
import { Footer, LoadingSpinner, RatingStars, ReviewCard, WineCard } from './components'

// Router moved to `src/router/index.ts`

// Toast configuration
const toastOptions = {
    position: 'top-right' as const,
    timeout: 3000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: 'button',
    icon: true,
    rtl: false,
}

// Create app
const app = createApp(App)
const pinia = createPinia()

// Register global components
app.component('Footer', Footer)
app.component('WineCard', WineCard)
app.component('ReviewCard', ReviewCard)
app.component('RatingStars', RatingStars)
app.component('LoadingSpinner', LoadingSpinner)

app.use(pinia)
app.use(router)
app.use(Toast, toastOptions)

app.mount('#app')
